export const getPartStatus = (status, selected_quantity) => {
  var select_status = "";

  if (status !== undefined 
      && Object.keys(status).length !== 0 
      && (selected_quantity in status)){
      select_status = status[selected_quantity];
  }

  return select_status;
};

export const getPartPurchaseStatus = (purchase_status, selected_quantity) => {
  var select_purchase_status = "";

  if (status !== undefined 
      && Object.keys(purchase_status).length !== 0 
      && (selected_quantity in purchase_status)){
      select_purchase_status = purchase_status[selected_quantity];
  }

  return select_purchase_status;
};

export const rowPartClass = (status, purchase_status) => {
  var row_class = "";

  if (purchase_status == ""
      && status != "enough-stock"
      && status != "substitute"){
        if (status == "not-found" || status == "no-stock" || status == ""){
          row_class = "part-problem";
        }
        if (status == "no-perfect-match" || status == "no-enough-stock"){
          row_class = "part-warning";
        }
  }
  return row_class;
};

export const getDatasheetUrl = (urls, selected_quantity) => {
  var url =  "";
  
  if (urls !== undefined 
      && typeof(urls) == "object"
      && Object.keys(urls).length !== 0 
      && (selected_quantity in urls)){
        url = urls[selected_quantity];
  }else{
    if (urls !== undefined 
        && typeof(urls) == "string"){
          url = urls;
    }
  }
  return url;
};

export const getImageSrc = (images, selected_quantity) => {
  var image_src = "";
  if (images 
      && images !== undefined 
      && typeof(images) == "object"
      && Object.keys(images).length !== 0 
      && (selected_quantity in images)){
        image_src = images[selected_quantity];
  }else{
    if (images 
        && images !== undefined 
        && typeof(images) == "string"){
          image_src = images
    }
  }
  return image_src;
};

export const getPartSock = (stocks, selected_quantity) => {
  var stock = "-"
  if (stocks !== undefined 
      && typeof(stocks) == "object"
      && Object.keys(stocks).length !== 0 
      && (selected_quantity in stocks)){
        stock = stocks[selected_quantity];
  }else{
    if (stocks !== undefined 
        && typeof(stocks) == "number"){
          stock = stocks;
    }
  }
  return stock;
};

export const max_number_options = (options) => {
  var rowspan = 1;
  if (options !== undefined 
      && typeof(options) == "object"
      && Object.keys(options).length !== 0 ){

    var lengths = []
    Object.entries(options).forEach(([key, value]) => {
      if (value.length != 0){
        lengths.push(value.length);
      }
    });
    
    rowspan = Math.max(...lengths);
  }

  return rowspan;
};

export const max_number_options_substitutes = (options) => {
  var rowspan = 1;
  if (options !== undefined 
      && typeof(options) == "object"
      && Object.keys(options).length !== 0 ){
    var lengths = 0
    options.map((value) => {
      if (value.check !== undefined && value.check){
        lengths ++;
      }
    });
    
    rowspan = lengths;
  }
  return rowspan;

}